module.exports = __webpack_public_path__ + "static/img/IMG_0872.69cf437.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0872.jpg
// module id = TxrE
// module chunks = 12